const shadows = {
  outline: '0 0 0 3px var(--cassini-colors-focus)',
};

export default shadows;
